// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-details-container {
    width: calc(98% - 1rem) !important;
    height: 32vh !important;
    overflow: scroll;
    margin: 1rem 1rem 0rem 1rem;
}

.return-details-container {
    width: calc(98% - 1rem) !important;
    overflow: scroll;
    position: relative;
    margin: 1rem 1rem 0rem 1rem;
    height: 32vh !important;
}

.custom-table {
    width: 100%;
    table-layout: fixed;
}

.custom-table table {
    border: none !important;
    border-radius: 1px;
}

.custom-table thead {
    background-color: #abb4b3;
    color: var(--surface-g5);
    position: sticky;
    top: 0;
    z-index: 1;
}

.custom-table th {
    background-color: var(--surface-g1);
}

.custom-table th,
.custom-table td {
    padding: 8px;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border: none !important;
}

.custom-table tbody {
    max-height: calc(100vh - 12rem);
    overflow-y: scroll;
    font-size: 0.813rem;
}

.custom-table tbody tr {
  height: 42px;
}

.return-active-row {
    background-color: #0860E6;
    color: white;
    cursor: pointer;
}

.return-flex-box {
    display: flex;
    justify-content: flex-start;
    gap: 1rem;
    font-size: 0.813rem;
}

.return-flex-box-container {
    margin-bottom: 1rem;
}

.return-flex-box p {
    margin: 0;
    padding: 0.5rem 0;
    text-align: left;
    border-bottom: 1px solid var(--surface-g1);
    width: 100%;
}

.return-flex-box p:first-child {
    width: 150px;
    flex-shrink: 0;
}

.returned-qty-input {
    text-align: center;
    width: 100%;
    border: none;
    outline: none;
}

.product-name-column {
    width: 300px !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.quantity-modal-table tbody tr {
  height: 44px;
}

.quantity-modal-table thead tr {
  height: 44px;
}

.quantity-modal-table th {
    background-color: var(--surface-g0);
}

.quantity-modal-table tr {
    text-align: center;
}

.return-item-name {
    font-weight: bold;
    text-align: left;
    font-size: 1rem;
    position: relative;
    z-index: 1210;
    margin-left: 1rem;

}

.order-item-name {
    font-weight: bold;
    text-align: left;
    font-size: 1rem;
    margin-left: 1rem;
    margin-bottom: 6px;
}


.table-small-column {
    width: 40px !important;
}

.table-small-delete {
    width: 60px !important;
}

.table-small-price {
    width: 150px !important;
}

.greyed-out-row {
    background-color: rgba(168, 175, 182, 0.529);
}

.return-item-modal-heading-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.return-item-name-modal {
    font-weight: bold;
    font-size: 1.25rem;
    margin-top: 1rem;
}

.no-outline:focus {
    outline: none;
}

.return-wrapper-input-box {
    position: relative;
    display: flex;
    width: 30%;
}

.return-search-input {
    width: 100%;
    padding: 9px 10px 9px 36px;
    font-size: 14px;
    border: 1px solid var(--surface-g1);
    background-color: var(--surface-g0);
    border-radius: 4px;
}

.return-search-icon {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    color: #888;
}

.suggestions-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: #fff;
    border: 1px solid #ccc;
    border-top: none;
    z-index: 1000;
    max-height: 200px;
    overflow-y: auto;
    list-style: none;
    margin: 0;
    padding: 0;
}

.suggestions-dropdown li {
    padding: 10px;
    cursor: pointer;
    background-color: white !important;
    color: black !important;
}

.dark .suggestions-dropdown li {
    background-color: var(--dark-background) !important;
    color: white !important;
}

.suggestions-dropdown li:hover {
    background-color: #c4b9b9;
}

.return-search-flex-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0rem 2rem 0rem 1rem;
}

.return-search-text {
    color: black !important;
}

.return-refund-mode-box {
    display: flex;
    gap: 0.5rem;
    padding: 1rem 0rem;
}

.btn-hgt {
    height: 2rem !important;
    width: 6rem !important;
    font-size: .8rem !important;
}

.return-refund-mode-head {
    font-size: 1rem !important;
    font-weight: bold !important;
    color: black;
    margin-top: 12px !important;
}

.dark .return-refund-mode-head {
    color: white;
}

.refund-mode-amount-text {
    border: 1.5px solid var(--surface-g2);
    padding: 0.5rem 1rem;
    border-radius: 8px;
    font-weight: 700;
    margin-bottom: 8px;
}

.payment-disabled {
    pointer-events: none;
    opacity: 0.5;
}

.dark .refund-mode-amount-text {
    color: white;
}

.refund-mode-select-btn {
    width: 8rem;
    margin-left: auto;
    height: 2.7rem;
}

.refund-modal-popup {
    background-color: white !important;
}

.dark .refund-modal-popup {
    background-color: var(--dark-background) !important;
}

.mrp-popup-box-quantityValidationModal {
    display: flex;
    gap: 1rem;
    margin-top: 10px;
}

.refund-modal-popup-text {
    font-size: 1.25rem;
    font-weight: 700;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.refund-modal-popup-details-text {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid var(--surface-g1);
}

/* ════════════════════════════════════════════════════
   DARK THEME — Returns components
   ════════════════════════════════════════════════════ */
.dark .custom-table thead,
.dark .custom-table th {
  background-color: #1e293b;
  color: #94a3b8;
}
.dark .custom-table tbody tr:nth-child(odd) {
  background-color: #0f172a;
}
.dark .custom-table tbody tr:nth-child(even) {
  background-color: #111827;
}
.dark .custom-table td {
  color: #e2e8f0;
  border-bottom-color: #334155 !important;
}
.dark .return-active-row {
  background-color: #1d4ed8;
}
.dark .return-search-input {
  background-color: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}
.dark .return-search-icon {
  color: #64748b;
}
.dark .suggestions-dropdown {
  background: #1e293b;
  border-color: #334155;
}
.dark .return-search-text {
  color: #e2e8f0 !important;
}
.dark .return-refund-mode-head {
  color: #e2e8f0;
}
.dark .refund-modal-popup-text {
  color: #f1f5f9;
}
.dark .refund-modal-popup-details-text {
  color: #e2e8f0;
  border-bottom-color: #334155;
}
.dark .return-value-bar {
  background: #1e293b;
}
.dark .return-value-bar-text {
  border-color: #475569;
  color: #e2e8f0;
}
.dark .return-item-name,
.dark .order-item-name {
  color: #f1f5f9;
}
.dark .return-flex-box p {
  border-bottom-color: #334155;
  color: #e2e8f0;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/Returns/components/style.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,0CAA0C;IAC1C,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,iBAAiB;;AAErB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,eAAe;IACf,mCAAmC;IACnC,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,eAAe;IACf,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,mDAAmD;IACnD,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;;yDAEyD;AACzD;;EAEE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,uCAAuC;AACzC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,cAAc;AAChB","sourcesContent":[".order-details-container {\n    width: calc(98% - 1rem) !important;\n    height: 32vh !important;\n    overflow: scroll;\n    margin: 1rem 1rem 0rem 1rem;\n}\n\n.return-details-container {\n    width: calc(98% - 1rem) !important;\n    overflow: scroll;\n    position: relative;\n    margin: 1rem 1rem 0rem 1rem;\n    height: 32vh !important;\n}\n\n.custom-table {\n    width: 100%;\n    table-layout: fixed;\n}\n\n.custom-table table {\n    border: none !important;\n    border-radius: 1px;\n}\n\n.custom-table thead {\n    background-color: #abb4b3;\n    color: var(--surface-g5);\n    position: sticky;\n    top: 0;\n    z-index: 1;\n}\n\n.custom-table th {\n    background-color: var(--surface-g1);\n}\n\n.custom-table th,\n.custom-table td {\n    padding: 8px;\n    text-align: left;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    border: none !important;\n}\n\n.custom-table tbody {\n    max-height: calc(100vh - 12rem);\n    overflow-y: scroll;\n    font-size: 0.813rem;\n}\n\n.custom-table tbody tr {\n  height: 42px;\n}\n\n.return-active-row {\n    background-color: #0860E6;\n    color: white;\n    cursor: pointer;\n}\n\n.return-flex-box {\n    display: flex;\n    justify-content: flex-start;\n    gap: 1rem;\n    font-size: 0.813rem;\n}\n\n.return-flex-box-container {\n    margin-bottom: 1rem;\n}\n\n.return-flex-box p {\n    margin: 0;\n    padding: 0.5rem 0;\n    text-align: left;\n    border-bottom: 1px solid var(--surface-g1);\n    width: 100%;\n}\n\n.return-flex-box p:first-child {\n    width: 150px;\n    flex-shrink: 0;\n}\n\n.returned-qty-input {\n    text-align: center;\n    width: 100%;\n    border: none;\n    outline: none;\n}\n\n.product-name-column {\n    width: 300px !important;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\n.quantity-modal-table tbody tr {\n  height: 44px;\n}\n\n.quantity-modal-table thead tr {\n  height: 44px;\n}\n\n.quantity-modal-table th {\n    background-color: var(--surface-g0);\n}\n\n.quantity-modal-table tr {\n    text-align: center;\n}\n\n.return-item-name {\n    font-weight: bold;\n    text-align: left;\n    font-size: 1rem;\n    position: relative;\n    z-index: 1210;\n    margin-left: 1rem;\n\n}\n\n.order-item-name {\n    font-weight: bold;\n    text-align: left;\n    font-size: 1rem;\n    margin-left: 1rem;\n    margin-bottom: 6px;\n}\n\n\n.table-small-column {\n    width: 40px !important;\n}\n\n.table-small-delete {\n    width: 60px !important;\n}\n\n.table-small-price {\n    width: 150px !important;\n}\n\n.greyed-out-row {\n    background-color: rgba(168, 175, 182, 0.529);\n}\n\n.return-item-modal-heading-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.return-item-name-modal {\n    font-weight: bold;\n    font-size: 1.25rem;\n    margin-top: 1rem;\n}\n\n.no-outline:focus {\n    outline: none;\n}\n\n.return-wrapper-input-box {\n    position: relative;\n    display: flex;\n    width: 30%;\n}\n\n.return-search-input {\n    width: 100%;\n    padding: 9px 10px 9px 36px;\n    font-size: 14px;\n    border: 1px solid var(--surface-g1);\n    background-color: var(--surface-g0);\n    border-radius: 4px;\n}\n\n.return-search-icon {\n    position: absolute;\n    top: 50%;\n    left: 10px;\n    transform: translateY(-50%);\n    color: #888;\n}\n\n.suggestions-dropdown {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    background: #fff;\n    border: 1px solid #ccc;\n    border-top: none;\n    z-index: 1000;\n    max-height: 200px;\n    overflow-y: auto;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.suggestions-dropdown li {\n    padding: 10px;\n    cursor: pointer;\n    background-color: white !important;\n    color: black !important;\n}\n\n.dark .suggestions-dropdown li {\n    background-color: var(--dark-background) !important;\n    color: white !important;\n}\n\n.suggestions-dropdown li:hover {\n    background-color: #c4b9b9;\n}\n\n.return-search-flex-box {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0rem 2rem 0rem 1rem;\n}\n\n.return-search-text {\n    color: black !important;\n}\n\n.return-refund-mode-box {\n    display: flex;\n    gap: 0.5rem;\n    padding: 1rem 0rem;\n}\n\n.btn-hgt {\n    height: 2rem !important;\n    width: 6rem !important;\n    font-size: .8rem !important;\n}\n\n.return-refund-mode-head {\n    font-size: 1rem !important;\n    font-weight: bold !important;\n    color: black;\n    margin-top: 12px !important;\n}\n\n.dark .return-refund-mode-head {\n    color: white;\n}\n\n.refund-mode-amount-text {\n    border: 1.5px solid var(--surface-g2);\n    padding: 0.5rem 1rem;\n    border-radius: 8px;\n    font-weight: 700;\n    margin-bottom: 8px;\n}\n\n.payment-disabled {\n    pointer-events: none;\n    opacity: 0.5;\n}\n\n.dark .refund-mode-amount-text {\n    color: white;\n}\n\n.refund-mode-select-btn {\n    width: 8rem;\n    margin-left: auto;\n    height: 2.7rem;\n}\n\n.refund-modal-popup {\n    background-color: white !important;\n}\n\n.dark .refund-modal-popup {\n    background-color: var(--dark-background) !important;\n}\n\n.mrp-popup-box-quantityValidationModal {\n    display: flex;\n    gap: 1rem;\n    margin-top: 10px;\n}\n\n.refund-modal-popup-text {\n    font-size: 1.25rem;\n    font-weight: 700;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.refund-modal-popup-details-text {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 8px;\n    padding-bottom: 8px;\n    border-bottom: 1px solid var(--surface-g1);\n}\n\n/* ════════════════════════════════════════════════════\n   DARK THEME — Returns components\n   ════════════════════════════════════════════════════ */\n.dark .custom-table thead,\n.dark .custom-table th {\n  background-color: #1e293b;\n  color: #94a3b8;\n}\n.dark .custom-table tbody tr:nth-child(odd) {\n  background-color: #0f172a;\n}\n.dark .custom-table tbody tr:nth-child(even) {\n  background-color: #111827;\n}\n.dark .custom-table td {\n  color: #e2e8f0;\n  border-bottom-color: #334155 !important;\n}\n.dark .return-active-row {\n  background-color: #1d4ed8;\n}\n.dark .return-search-input {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n.dark .return-search-icon {\n  color: #64748b;\n}\n.dark .suggestions-dropdown {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .return-search-text {\n  color: #e2e8f0 !important;\n}\n.dark .return-refund-mode-head {\n  color: #e2e8f0;\n}\n.dark .refund-modal-popup-text {\n  color: #f1f5f9;\n}\n.dark .refund-modal-popup-details-text {\n  color: #e2e8f0;\n  border-bottom-color: #334155;\n}\n.dark .return-value-bar {\n  background: #1e293b;\n}\n.dark .return-value-bar-text {\n  border-color: #475569;\n  color: #e2e8f0;\n}\n.dark .return-item-name,\n.dark .order-item-name {\n  color: #f1f5f9;\n}\n.dark .return-flex-box p {\n  border-bottom-color: #334155;\n  color: #e2e8f0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
